module.exports = __webpack_public_path__ + "static/media/joz.cc529efb.jpg";